import { InjectionToken } from '@angular/core';
import { BreadcrumbItem } from './breadcrumb-item.model';

export const BREADCRUMB_HOME_ITEM = new InjectionToken<BreadcrumbItem>('Breadcrumb home item');
